import React from 'react';
import styled from 'styled-components';
import { DelSvg } from '@/features/editor/widgets/custom-widget/loading-section/shared/icons/delSvg';

export function DeleteBtn({
  onDelete,
  slotNum,
  margin,
}: {
  onDelete: () => void;
  slotNum: number;
  margin?: string;
}) {
  if (typeof slotNum === `undefined`) {
    return null;
  }
  return (
    <Wrapper>
      <IconButton margin={margin} onClick={onDelete}>
        <DelSvg />
      </IconButton>
    </Wrapper>
  );
}

const Wrapper = styled.div``;

const IconButton = styled.button`
  margin: ${(p) => p.margin || `0 0.5rem`};
  ${(p) => (p.disabled ? `opacity: 0.5;` : `cursor: pointer;`)}
  border-radius: 50%;

  svg > g > g {
    stroke: #798794;
  }

  svg:hover > g > g {
    stroke: black;
  }

  svg > g {
    opacity: 1;
  }

    ${(p) =>
      p.disabled
        ? ``
        : `
  svg {
    &:hover {
    rect {
      fill: black;
    }
      g {
        opacity: 1;

      }
    }

    &:active {
      rect {
      fill: #b6bac5;
    }
      g {
        opacity: 0.5;

      }
    }
  }
        `}
  }
`;
